module.exports = new __parcel__URL__("machine_activate_button.04173d56.png").toString();